import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from './Reveal';
import icons from '../../assets/serviceIcons';
import art from '../../assets/generated';

const ServiceCard = ({ service, index = 0 }) => (
  <Reveal delay={Math.min(index * 0.06, 0.4)} className="h-full">
    <Link
      to={`/services/${service.slug}`}
      className="group relative flex h-full flex-col overflow-hidden card transition-all duration-300 ease-spring hover:-translate-y-1.5 hover:shadow-lift hover:border-secondary/30"
    >
      <img
        src={art[`service-${service.slug}`]}
        alt=""
        aria-hidden="true"
        width="1200"
        height="800"
        loading="lazy"
        decoding="async"
        className="h-24 w-full object-cover sm:h-28"
      />
      <div className="flex flex-grow flex-col p-6 sm:p-7">
      <div className="-mt-11 mb-5 inline-flex w-fit rounded-2xl bg-white p-3 shadow-soft ring-1 ring-primary/5">
        <img
          src={icons[service.icon]}
          alt=""
          aria-hidden="true"
          width="64"
          height="64"
          loading="lazy"
          decoding="async"
          className="w-12 h-12 object-contain"
        />
      </div>

      <h3 className="font-display text-xl font-bold text-primary group-hover:text-secondary transition-colors">
        {service.name}
      </h3>
      <p className="mt-3 flex-grow text-accent leading-relaxed">{service.tagline}</p>

      <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-secondary">
        Learn more
        <ArrowUpRight
          size={16}
          aria-hidden="true"
          className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </span>
      </div>
    </Link>
  </Reveal>
);

export default ServiceCard;
